import { useDispatch, useSelector } from "react-redux";
import { SET_NO_GST__DATA } from "../../redux/ActionName/ActionName";
import { useState } from "react";
import { setDataAction } from "../../redux/Actions/SetDataAction";

export default function ToggleSwitch() {
    const [on, setOn] = useState(false);
    const dispatch = useDispatch();


    const handelToggalChange = () => {
        const newValue = !on;
        setOn(newValue);
        dispatch(setDataAction(newValue, SET_NO_GST__DATA));
    };

    return (
        <div className="flex items-center gap-3">
            <button
                onClick={handelToggalChange}
                className={`w-12 h-6 flex items-center rounded-full p-1 transition-colors duration-200 ${on ? "bg-black" : "bg-gray-300"
                    }`}
            >
                <div
                    className={`bg-white w-4 h-4 rounded-full shadow-md transform transition-transform duration-200 ${on ? "translate-x-6" : "translate-x-0"
                        }`}
                />
            </button>

        </div>
    );
}



export function SelectedQuestion({ groupIndex, isActive, onToggle }) {
    return (
        <div className="flex items-center gap-3">
            <button
                onClick={() => onToggle(groupIndex)}
                className={`w-12 h-6 flex items-center rounded-full p-1 transition-colors duration-200 ${isActive ? "bg-blue-500" : "bg-gray-300"
                    }`}
            >
                <div
                    className={`bg-white w-4 h-4 rounded-full shadow-md transform transition-transform duration-200 ${isActive ? "translate-x-6" : "translate-x-0"
                        }`}
                />
            </button>
        </div>
    );
}

